<template>
    <div>
        <p class="subtitle-2">
            <v-icon left>mdi-text-box-search-outline</v-icon>
            {{ $t('customer.plan.modules.title') }}
        </p>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            {{
                                $t('customer.plan.modules.table.headers.module')
                            }}
                        </th>
                        <th class="text-right">
                            {{
                                $t('customer.plan.modules.table.headers.amount')
                            }}
                        </th>
                        <th class="text-right" v-if="isBillable">
                            {{
                                $t(
                                    'customer.plan.modules.table.headers.cplug-value',
                                )
                            }}
                        </th>
                        <th class="text-right" v-if="isBillable">
                            {{
                                $t(
                                    'customer.plan.modules.table.headers.customer-value',
                                )
                            }}
                        </th>
                        <th class="text-right" v-if="!isBillable">
                            {{
                                $t('customer.plan.modules.table.headers.value')
                            }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="plan">
                    <tr v-for="(item, index) in plan.planModules" :key="index">
                        <td class="text-left">{{ item.name }}</td>
                        <td class="text-right">
                            {{ item.amount ? item.amount : 1 }}
                        </td>
                        <td class="text-right">
                            {{ $n(item.price, 'currency') }}
                        </td>
                        <td class="text-right" v-if="isBillable">
                            {{ $n(item.over_price, 'currency') }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong
                                >{{
                                    $t('customer.plan.modules.total')
                                }}:</strong
                            >
                        </td>
                        <td class="text-right">
                            <strong>{{ $n(plan.value, 'currency') }}</strong>
                        </td>
                        <td class="text-right" v-if="isBillable">
                            <strong>{{
                                $n(plan.over_value, 'currency')
                            }}</strong>
                        </td>
                    </tr>

                    <template v-if="discount > 0">
                        <tr>
                            <td colspan="2">
                                <strong
                                    >{{
                                        $t('customer.plan.modules.discount')
                                    }}:</strong
                                >
                            </td>
                            <td class="text-right">
                                <strong class="red--text">{{
                                    $n(discount, 'currency')
                                }}</strong>
                            </td>
                            <td v-if="isBillable"></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong
                                    >{{
                                        $t(
                                            'customer.plan.modules.total-discount',
                                        )
                                    }}:</strong
                                >
                            </td>
                            <td class="text-right">
                                <strong>{{
                                    $n(plan.final_price, 'currency')
                                }}</strong>
                            </td>
                            <td v-if="isBillable"></td>
                        </tr>
                    </template>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import Plan from '@/models/Plan'

export default {
    props: {
        planId: {
            required: true,
        },
        isBillable: {
            type: Boolean,
            default: () => true,
        },
    },

    data: () => {
        return {
            plan: null,
        }
    },

    created() {
        this.getPlan()
    },

    methods: {
        async getPlan() {
            let model = new Plan()
            this.plan = await model.with('planModules').find(this.planId)
        },
    },

    computed: {
        discount() {
            return this.plan.value - this.plan.final_price
        },
    },
}
</script>
